import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Alex Efremo
 * id A0678E6D-C3D3-42AB-B9E7-C1B12D368B70
 * name treasure-chest
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/treasure-chest.svg
 * tags
 * - Gaming / RPG 
 * - Shopping 
 * - Lock 
 */
export const TreasureChestIcon = createSvgIcon(<><path d="M5,4H19A3,3 0 0,1 22,7V11H15V10H9V11H2V7A3,3 0 0,1 5,4M11,11H13V13H11V11M2,12H9V13L11,15H13L15,13V12H22V20H2V12Z" /></>, 'TreasureChestIcon');
export default TreasureChestIcon